
export const environment = {
    production: false,
    URL_API:  'https://vision-anterior.dav.ac/api/',
    URL_SOCKET:  'https://vision-anterior.dav.ac',
    DRAFT_KEY: '5e068d1cb81d1c5f29b62977',
    STORAGE_FILES: 'https://vision-anterior.dav.ac/public/assets/',
    STORAGE_URL: 'https://vision-anterior.dav.ac/',    
};
